
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import BorderComplex from "@/components/Reusable/CustomInputs/BorderComplex.vue";
import { Control } from "@/oxygen/classes/lib/types";
import { UnitInputValue } from "@/types/unit";
import BorderRadius from "@/components/Reusable/CustomInputs/BorderRadius.vue";

type BorderValue = {
  top: {
    width: UnitInputValue;
    style: string;
    color: string;
  };
  right: {
    width: UnitInputValue;
    style: string;
    color: string;
  };
  bottom: {
    width: UnitInputValue;
    style: string;
    color: string;
  };
  left: {
    width: UnitInputValue;
    style: string;
    color: string;
  };
};

@Component({
  components: { BorderRadius, BorderComplex }
})
export default class OxygenBorderInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input")
  syncedValue?: BorderValue;

  @Prop()
  placeholder?: BorderValue;
}
